// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q6Sz","question":"styles_question__3vYtJ","inputVisibleButton":"styles_inputVisibleButton__2jc-r","note":"styles_note__OC1jV"};